import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {HttpService} from "../service/http-service";
import {API} from "../config/api-config";

declare var alertify:any;
@Component({
  templateUrl:"./productGenre.html"
})

export class ProductGenre implements OnInit{

  constructor(
    private router:Router,
    private http:HttpService
  ){}

  private data:any=[];

  private imagePath:string='';

  ngOnInit(): void {
    this.getPath();

  }

  private getPath():void{
    this.http.getData(API.resourcePath)
      .then(res=>{
        this.imagePath=res.data;
        this.getData();
      })
  }

  private updateProductGenres():void{
    let _self = this;
    alertify.confirm("從UPC更新產品分類","確定要從UPC更新產品分類嗎？",function () {
      _self.http.getData(API.product+'/batchUpdateProductGenreFromUpc').then(res=>{
        if(res.status.code==0){
          alertify.success(res.status.message);
          _self.getData();
        }else {
          alertify.error(res.status.message);
        }
      });
    },function () {

    })
  }

  private getData(){
    this.http.getData(API.productGenre).then(res=>{
      this.data=res.data;
      for (let i=0;i<this.data.length;i++){
        if(this.data[i].image!=''){
          this.data[i].image = this.imagePath+this.data[i].image;
        }
      }
    });
  }

  private editProductGenre(id:number){
    this.router.navigate(['index/product/genre',id]);
  }



}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/product/ProductGenre.componment.ts